var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnticipatedCharges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6673 34.6875H5.50065C2.92332 34.6875 0.833984 32.5982 0.833984 30.0208V5.52079C0.833984 2.94346 2.92332 0.854126 5.50065 0.854126H20.084L30.0007 10.7708V34.6875",
    stroke: "#C5A605",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4186 11.354H19.502V1.43738",
    stroke: "#C5A605",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.543 20.1041V25.9375",
    stroke: "#C5A605",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0007 34.6875C23.0007 35.4928 22.3476 36.1458 21.5423 36.1458C20.737 36.1458 20.084 35.4928 20.084 34.6875C20.084 33.8822 20.737 33.2291 21.5423 33.2291C22.3476 33.2291 23.0007 33.8822 23.0007 34.6875Z",
    stroke: "#C5A605",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnticipatedCharges);
export default __webpack_public_path__ + "static/media/anticipated-charges.c216d27142037f4ed75eefe0a045bf7b.svg";
export { ForwardRef as ReactComponent };